function drawRotatedImage(ctx,img,x, y, angle,percent_size,opacity) {
    if(!percent_size){
        percent_size=100;
    }
    if(typeof opacity=="undefined"){
        opacity=-1;
    }
    ctx.save(); 
    if(opacity!=-1){
        ctx.globalAlpha = opacity/100;
    }
    ctx.translate(x, y);
    ctx.rotate(angle * Math.PI/180);
    drawImage(ctx,img,0,0,percent_size);
    ctx.restore(); 
}
function drawRotatedImageByPoint(ctx,img,x, y, angle,point_image,percent_size) {
    if(!percent_size){
        percent_size=100;
    }
    ctx.save(); 
//    ctx.translate(x+point_image[0], y+point_image[1]);
    ctx.translate(x+point_image[0]-img.width/2, y+point_image[1]-img.height/2);
    ctx.rotate(angle * Math.PI/180);
//    ctx.translate(-img.width/2, -img.height/2);
    ctx.drawImage(img, -point_image[0], -point_image[1],img.width*percent_size/100,img.height*percent_size/100);
    ctx.restore(); 
    
}
function drawImageCrop(ctx,img,x,y,crop_x,crop_y,crop_width,crop_height){
    ctx.drawImage(img,crop_x,crop_y,crop_width,crop_height,x,y,crop_width,crop_height);
}

function drawImageCropCenter(ctx,img,x,y,crop_x,crop_y,crop_width,crop_height,percent_size,opacity){
    //drawImageCropCenter(ctx,qimg,300,300,0,0,557,600);
//    ctx.drawImage(img,crop_x,crop_y,crop_width,crop_height,x-Math.round(img.width/2),y-Math.round(img.height/2),crop_width,crop_height);
    if(!percent_size){
        percent_size=100;
    }
    if(typeof opacity=="undefined"){
        opacity=-1;
    }
    ctx.save();
    if(opacity!=-1){
        ctx.globalAlpha = opacity/100;
    }
    ctx.drawImage(img,
        crop_x,crop_y,
        crop_width,crop_height,
        x-Math.round(crop_width*percent_size/100/2),y-Math.round(crop_height*percent_size/100/2),
        Math.round(crop_width*percent_size/100),Math.round(crop_height*percent_size/100));
    ctx.restore();
}
function getTextSize(ctx,text,font_family,font_size){
    function getTextHeight() {
        var text = $('<span style="fontFamily:'+font_family+';font-size:'+font_size+'px">Hg</span>');
        var block = $('<div style="display: inline-block; width: 1px; height: 0px;"></div>');

        var div = $('<div style="position:absolute:left:0px;top:0px;"></div>');
        div.append(text, block);
        var body = $('body');
        body.append(div);
        try {
            var result = {};
            block.css({ verticalAlign: 'baseline' });
            result.ascent = block.offset().top - text.offset().top;
            block.css({ verticalAlign: 'bottom' });
            result.height = block.offset().top - text.offset().top;
            result.descent = result.height - result.ascent;

        } finally {
            div.remove();
        }
        return result;
    };

    var font=font_size+"px "+font_family;
    ctx.save();
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top'; // important!
    ctx.font = font;
    var width=ctx.measureText(text).width;
    ctx.restore();


    return [width,getTextHeight().height];
}

function drawText(ctx,text,pos,font_size,font_family,color,color_shadow,width_shadow,opacity,text_size){
    if(!width_shadow){
        width_shadow=1;
    }
    if(typeof opacity=="undefined"){
        opacity=-1;
    }
    if(typeof text_size[0]== "undefined"){
        text_size=getTextSize(ctx,text,font_family,font_size);
    }

    var font=font_size+"px "+font_family;
    ctx.save();
    if(opacity!=-1){
        ctx.globalAlpha = opacity/100;
    }
    ctx.fillStyle = color;
    if(color_shadow){
        ctx.strokeStyle = color_shadow;
    }
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top'; // important!
    ctx.font = font;
    var w=text_size[0];
    var h=text_size[1];

    var x=pos[0]-Math.round(w/2),y=pos[1]-Math.round(h/2);
    if(color_shadow){
        ctx.lineWidth = width_shadow;
        ctx.strokeStyle = color_shadow;
        ctx.strokeText(text, x, y);
    }
    ctx.fillText(text, x, y);

    ctx.restore();

    // Canvas can tell us the width

//    var x=pos[0],y=pos[1];
//    h = getTextHeight(font);
//    testLine(ctx, x, y, w, 'red');
//    testLine(ctx, x, y + h.ascent, w, 'green');
//    testLine(ctx, x, y + h.descent, w, 'pink');
//    testLine(ctx, x, y + h.height, w, 'blue');




}

function drawImage(ctx,img,x,y,percent_size,opacity){
    if(!percent_size){
        percent_size=100;
    }
    if(!x){
        x=0;
    }
    if(!y){
        y=0;
    }
    if(typeof opacity=="undefined"){
        opacity=-1;
    }
    if(opacity!=-1){
        ctx.save();
        ctx.globalAlpha = opacity/100;
    }
    ctx.drawImage(img, x-(img.width*percent_size/100/2), y-(img.height*percent_size/100/2),img.width*percent_size/100,img.height*percent_size/100);
    if(opacity!=-1){
        ctx.restore();
    }
}
$(function(){
    
    
    
    
    
    
    var _animIndex={},_animStorage={},
    _collisionPointObj={},_collisionPointObjArr={},_collisionPointObjLast={},_collisionPointAdr={},
    _cutStorage={},_eventLog={};
    $.girlAnimTest=function(){
        debugArr(_animIndex);
    };
    $.fn.startGirlAnim=function(options,timeHandler){
        
        var th=$(this);
        var settings=th.data("myGirlAnim");
        var animIndex;
        var tryToInit=0;
        
        function isCollisionNewCut(){
            
            if(typeof _collisionPointObj[animIndex][0]=="undefined"){
                _cutStorage[animIndex]++;
                _cutStorage[animIndex]=_cutStorage[animIndex]%100000;
                return 1;
            }
            return 0;
        }
        function isInImage(img,img_size,pos_org,angle){
            var pos=copyArray(pos_org);
            if(typeof angle=="undefined"){
                angle=0;
            }
            var c = document.createElement('canvas');
//            c=$("#bookGameTest")[0];
            var a=Math.max(img_size[0],img_size[1])*2;
            c.width=a;
            c.height=a;

            var ctx=c.getContext("2d");
//            ctx.beginPath();
//            ctx.rect(0, 0, a, a);
//            ctx.fillStyle = "green";
//            ctx.fill();
            ctx.save(); 
            ctx.translate(c.width/2,c.height/2);
            if(angle){
                ctx.rotate(angle * Math.PI/180);
            }
            ctx.drawImage(img, 0, 0,img_size[0],img_size[1],-Math.round(img_size[0]/2),-Math.round(img_size[1]/2),img_size[0],img_size[1]);
            ctx.restore(); 
            
            pos[0]+=c.width/2-Math.round(img_size[0]/2);
            pos[1]+=c.height/2-Math.round(img_size[1]/2);
            pos[0]=Math.floor(pos[0]);
            pos[1]=Math.floor(pos[1]);
            var imageData = ctx.getImageData(0, 0, c.width, c.height);
            var pixel_start=4*(c.width*pos[1]+pos[0]);
//            console.log(imageData.data);
//            ctx.fillStyle = "rgb(255,0,0)";
//            ctx.beginPath();
//            ctx.arc(pos[0], pos[1], 4, 0, Math.PI*2, true); 
//            ctx.closePath();
//            ctx.fill();
//            _collisionPointAdr[animIndex]=[];


//            return 0;


            if(imageData.data[pixel_start+3]!=0){
                return 1;
            }
            return 0;
        }
        function isInImageArr(img,img_size,angle,img_pos,collisionPointArr){
            if(typeof angle=="undefined"){
                angle=0;
            }
            var c = document.createElement('canvas');
            var a=Math.max(img_size[0],img_size[1])*2;
            c.width=a;
            c.height=a;

            var ctx=c.getContext("2d");
            
            ctx.save(); 
            ctx.translate(c.width/2,c.height/2);
            ctx.rotate(angle * Math.PI/180);
            ctx.drawImage(img, 0, 0,img_size[0],img_size[1],-Math.round(img_size[0]/2),-Math.round(img_size[1]/2),img_size[0],img_size[1]);
            ctx.restore(); 
            
            var imageData = ctx.getImageData(0, 0, c.width, c.height);
            
            
            var i,pos=[],pos_org,pixel_start,log=[];
            for(i in collisionPointArr){
                pos_org=collisionPointArr[i];
                if(pos_org[2]){
                    pos[0]=pos_org[0];
                    pos[1]=pos_org[1];
                    pos[0]-=img_pos[0];
                    pos[1]-=img_pos[1];
                    pos[0]+=c.width/2;//don't have to minus img_size/2, arguments do that
                    pos[1]+=c.height/2;
                    pos[1]=c.height-pos[1];
                    pixel_start=4*(c.width*pos[1]+pos[0]);
                    if(imageData.data[pixel_start+3]==0){
                        pos_org[2]=0;
                    }
//                    log.push(pos[0]+"_"+pos[1]);
                }
            }
//            console.log(log);
//            $.qLog(pos[0]+"_"+pos[1]+"_"+imageData.data[pixel_start+3]+   "<br>");
//            console.log(collisionPointArr);
        }
         function prepareCollisionInShape(img,img_pos,img_size_org,angle){
            var collisionPointArr=copyArrayDim(_collisionPointObjArr[animIndex]),collisionPoint,i;
            var img_size=[],img_size_h=[];
            var need_check=0;
            img_size_h[0]=img_size_org[0]/2;
            img_size_h[1]=img_size_org[1]/2;
            
            if(settings.collision_easy){
                for(i in collisionPointArr){
                    collisionPoint=collisionPointArr[i];
                    if(img_pos[0]-img_size_h[0]<collisionPoint[0] && img_pos[0]+img_size_h[0]>collisionPoint[0] &&
                    img_pos[1]-img_size_h[1]<collisionPoint[1] && img_pos[1]+img_size_h[1]>collisionPoint[1] ){
                        collisionPoint[2]=1;
                    }
                    else{
                       collisionPoint[2]=0; 
                    }
                }
                return collisionPointArr;
            }
            
            
            img_size[0]=Math.max(img_size_org[0],img_size_org[1]);
            img_size[0]=Math.round(img_size_org[0]*0.71);
            img_size[1]=img_size[0];
            
            
            for(i in collisionPointArr){
                collisionPoint=collisionPointArr[i];
                if(img_pos[0]-img_size[0]<collisionPoint[0] && img_pos[0]+img_size[0]>collisionPoint[0] &&
                img_pos[1]-img_size[1]<collisionPoint[1] && img_pos[1]+img_size[1]>collisionPoint[1] ){
                    collisionPoint[2]=1;
                    need_check=1;
                }
                else{
                   collisionPoint[2]=0; 
                }
            }
            if(need_check){
                isInImageArr(img,img_size_org,angle,img_pos,collisionPointArr);
            }
            return collisionPointArr;
        }
        
        
        function isCollisionInShape(img,img_pos,img_size_org,angle){
            var collisionPoint=_collisionPointObj[animIndex];
            var img_size=[],img_size_h=[];
            
            img_size_h[0]=img_size_org[0]/2;
            img_size_h[1]=img_size_org[1]/2;
            if(settings.collision_easy){
                if(img_pos[0]-img_size_h[0]<collisionPoint[0] && img_pos[0]+img_size_h[0]>collisionPoint[0] &&
                    img_pos[1]-img_size_h[1]<collisionPoint[1] && img_pos[1]+img_size_h[1]>collisionPoint[1] ){
                    return 1;
                }
                return 0;
            }
            
            
            
            
            
            img_size[0]=Math.max(img_size_org[0],img_size_org[1]);
            img_size[0]=Math.round(img_size_org[0]*0.71);
            img_size[1]=img_size[0];
            
//            $.qLog(collisionPoint[0]+"_"+collisionPoint[1]+"->"+img_pos[0]+"_"+img_pos[1]+",  "+img_size[0]+"_"+img_size[1]+  "<br>");
            if(img_pos[0]-img_size[0]<collisionPoint[0] && img_pos[0]+img_size[0]>collisionPoint[0] &&
                img_pos[1]-img_size[1]<collisionPoint[1] && img_pos[1]+img_size[1]>collisionPoint[1] ){
                return isInImage(img,img_size_org,[collisionPoint[0]-img_pos[0]+img_size_h[0],-(collisionPoint[1]-img_pos[1]-img_size_h[1])],angle);
            }
            return 0;
        }
        function prepareCollisionObj(obj){
            var set={collLog:-1,eventType:"add",lastCut:0,cutRes:[],cutNumber:0,easyMobile:1};
            if(obj){
                set=$.extend(set,obj);
            }
            return set;
        }
        function isLastCut(collisionObj){
            if(collisionObj.lastCut==_cutStorage[animIndex]){
                return 1;
            }
            return 0;
        }
        function handleCollision(img,x,y,img_size,angle,collisionObj,curObj){
            var collisionPointArr=prepareCollisionInShape(img,[x,y],img_size,angle);
            var i,len=collisionPointArr.length;
            var cutNuber=0;
            if(len){
                if(collisionObj.cutRes.length>0){
                    len=collisionPointArr.unshift(copyArrayDim(collisionObj.cutRes));
                }
                for(i=0;i<=len-2;i++){
                    if(collisionPointArr[i][2]==1 && collisionPointArr[i+1][2]==0){
                        //cutLog

                        collisionObj.cutNumber++;
                        cutNuber++;
                        _eventLog[animIndex].push({event:"collisionEvent",eventType:collisionObj.eventType,imgPos:[x,y],colPos:_collisionPointObj[animIndex]});
                        th.trigger("collisionEvent",{
                            eventType:collisionObj.eventType,
                            imgPos:[x,y],
                            colPos:[collisionPointArr[i][0],collisionPointArr[i][1]]
                        });
                    }
                }
                collisionObj.cutRes=copyArrayDim(collisionPointArr[(len-1)]);
            }
            else{
                collisionObj.cutRes=[];
            }
            if(cutNuber){
                return 0;
            }
            return 1;
            //_isMobile
        }
        
        function handleCollision_old(img,x,y,img_size,angle,collisionObj,curObj){
            var curInShape=-1;
            if(_isMobile && settings.collision_easy){
                curInShape=isCollisionInShape(img,[x,y],img_size,angle);
                if(curInShape==1){
                    collisionObj.lastCut=_cutStorage[animIndex];
                    collisionObj.cutNumber++;
                    _eventLog[animIndex].push({event:"collisionEvent",eventType:collisionObj.eventType,imgPos:[x,y],colPos:_collisionPointObj[animIndex]})
                    th.trigger("collisionEvent",{eventType:collisionObj.eventType,imgPos:[x,y],colPos:_collisionPointObj[animIndex]});
                    return 0;
                }
            }
            
            if(isCollisionNewCut()){
                collisionObj.collLog=-1;
            }
            else{
                if(curInShape==-1){
                    curInShape=isCollisionInShape(img,[x,y],img_size,angle);
                }
                if(collisionObj.collLog==1 && curInShape==0){
                    //is collision
                    collisionObj.collLog=-1;
                    collisionObj.lastCut=_cutStorage[animIndex];
                    collisionObj.cutNumber++;
                    _eventLog[animIndex].push({event:"collisionEvent",eventType:collisionObj.eventType,imgPos:[x,y],colPos:_collisionPointObj[animIndex]});
                    th.trigger("collisionEvent",{eventType:collisionObj.eventType,imgPos:[x,y],colPos:_collisionPointObj[animIndex]});
                    return 0;
                }
                else{
                    collisionObj.collLog=curInShape;
                }
            }
            return 1;
        }
        
        var methods={
            addAnim:function(center){
                var obj_index=getNewObjectIndex(_animStorage[animIndex].obj_set);
                _animStorage[animIndex].obj_set[obj_index]=new objDrawElipse(center);
                return animIndex;
            },
            addAnimLines:function(start_point,img_name,scale,step_max,distance,opacity_arr){
                var obj_index=getNewObjectIndex(_animStorage[animIndex].obj_set);
                var obj=new objDrawLines(start_point,img_name,scale,step_max,distance,opacity_arr);
                
                _animStorage[animIndex].obj_set[obj_index]=obj;
                return animIndex;
            },
            addAnimCustom:function(start_point,end_point,img_name,step_max,scale_arr,opacity_arr,rotation_arr){
                var obj_index=getNewObjectIndex(_animStorage[animIndex].obj_set);
                _animStorage[animIndex].obj_set[obj_index]=new objDrawCustom(start_point,end_point,img_name,step_max,scale_arr,opacity_arr,rotation_arr);
                return animIndex;
            },
            addAnimClipCustom:function(start_point,end_point,img_arr,step_max,clip_period){
                var obj_index=getNewObjectIndex(_animStorage[animIndex].obj_set);
                _animStorage[animIndex].obj_set[obj_index]=new objDrawClipCustom(start_point,end_point,img_arr,step_max,clip_period);
                return animIndex;
            },
            addAnimRotation:function(start_point,img_name,point_image,speed){
                var obj_index=getNewObjectIndex(_animStorage[animIndex].obj_set);
                _animStorage[animIndex].obj_set[obj_index]=new objRotationAnim(start_point,img_name,point_image,speed);
                return animIndex;
            },
            addCollisionThrow:function(img,conf){
                var obj_index=getNewObjectIndex(_animStorage[animIndex].obj_set);
                _animStorage[animIndex].obj_set[obj_index]=new objCollisionThrow(img,conf);
                var pos_x= _animStorage[animIndex].obj_set[obj_index].takeStartX();
                return pos_x;
            },
            addCollisionStart:function(start_point,img){
                var obj_index=getNewObjectIndex(_animStorage[animIndex].obj_set);
                _animStorage[animIndex].obj_set[obj_index]=new objCollisionStart(start_point,img);
                return animIndex;
            },
            addCollisionPath:function(point_center,type){
                var obj_index=getNewObjectIndex(_animStorage[animIndex].obj_set);
                _animStorage[animIndex].obj_set[obj_index]=new objCollisionPath(point_center,type);
                return animIndex;
            },
            addText:function(txt,point_center,font_color,font_size,shadow_color,step_max,step_max_fadeout){
                var obj_index=getNewObjectIndex(_animStorage[animIndex].obj_set);
                _animStorage[animIndex].obj_set[obj_index]=new objShowText(txt,point_center,font_color,font_size,shadow_color,step_max,step_max_fadeout);
                return animIndex;
            },
            
            setCollisionPoint:function(point){
                _collisionPointAdr[animIndex]=point;
            },
            setEventLog:function(event_arr){
                _eventLog[animIndex]=event_arr;
            }
            
        };
        function objShowText(txt,point_center,font_color,font_size,shadow_color,step_max,step_max_fadeout){
            this.txt=txt;
            this.start=point_center;
            this.font_color=font_color?font_color:"#000000";
            this.font_size=font_size?font_size:25;
            this.shadow_color=shadow_color?shadow_color:"";
            this.step=0;
            this.step_max=step_max?step_max:0;
            this.step_max_fadeout=step_max_fadeout?step_max_fadeout:0;
            
            
        }
        objShowText.prototype={
            next:function(ctx){
                if(this.step_max>0){
                    this.step++;
                }
                ctx.save();
                
                ctx.textAlign = 'left';
                ctx.fillStyle = this.font_color;
                ctx.lineWidth = 3;
                ctx.font = this.font_size+'px Montserrat';
                if(this.shadow_color){
                    ctx.strokeStyle=this.shadow_color;
                }
                
                var text_width=ctx.measureText(this.txt).width;
                
                if(this.step_max_fadeout>0 && this.step>this.step_max){
                    ctx.globalAlpha   = 1-Math.min(1,(this.step-this.step_max)/this.step_max_fadeout);
                }
                
                ctx.strokeText(this.txt,Math.round(this.start[0]-text_width/2), this.start[1]);
                ctx.fillText(this.txt,Math.round(this.start[0]-text_width/2), this.start[1]);
                ctx.restore();
                if(this.step_max>0 && this.step_max+this.step_max_fadeout<=this.step){
                    return 0;
                }
                
                return 1;
                
            }
        };
        
        function objRotationAnim(start_point,img_name,point_image,speed){
            this.speed=speed;
            this.step=0;
            this.step_max=10000;
            this.start=start_point;
            this.imgName=img_name;
            this.point_image=point_image;
        }
        objRotationAnim.prototype={
            next:function(ctx,img){
                this.step+=this.speed;
                this.step=this.step%this.step_max;

                var x=this.start[0];
                var y=this.start[1];
                var angle=360*this.step/this.step_max;
                drawRotatedImageByPoint(ctx,img,x, y, angle,this.point_image); 
                
                return 1;
            }
        };
        
        
        function objCollisionStart(point_center,img){
            this.collisionObj=prepareCollisionObj();
            this.start=point_center;
            this.imgName="bad1";
            if(img){
                 this.imgName=img;
            }
        }
        objCollisionStart.prototype={
            next:function(ctx,img){
//                if(typeof img == "undefined"){
//                    return 1;
//                }
                var x=this.start[0];
                var y=this.start[1];
                var angle=0;
                if(!handleCollision(img,x,settings.height-y,[img.width,img.height],angle,this.collisionObj,this)){
                    //collision
                    return 0;
                }
                drawRotatedImage(ctx,img,x, y, angle);
                return 1;
            }
        };
        
        
        function objCollisionPath(point_center,type){
            this.step=1;
            this.type=type;
            this.collisionObj=prepareCollisionObj();
            if(type=="good"){
                this.imgName="good"+mt_rand(1,4);
            }
            else{
                this.imgName="bad"+mt_rand(1,4);
                this.collisionObj.eventType="minus";
            }
            
            
            this.animObj=[];
            this.pointNumber=0;
            var border_work=[170,980];
            border_work[2]=border_work[1]-border_work[0];
            var ctx_size=[settings.width, settings.height];
            var prop=Math.round((point_center[0]-border_work[0])/border_work[2]*100);
            if(prop<10){
                prop=0;
            }
            if(prop>90){
                prop=100;
            }
            var points=[],last_point,i,i_max=3,dis,x;
            
            
            function findPoint(last_point){
                var vec=makeVector(last_point,point_center,dis);
                var alfa=angleClockFromVector(vec);
                var beta=alfa+mt_rand(-60,60);
                beta-=90;
                var beta_r=beta/180*Math.PI;
                var v=[
                    dis*Math.cos(beta_r),
                    dis*Math.sin(beta_r)
                ];
                var next_point=addVector(last_point,v);
                next_point[0]=Math.max(next_point[0],border_work[0]);
                next_point[0]=Math.min(next_point[0],border_work[1]);
                next_point[1]=Math.max(20,next_point[1]);
                next_point[1]=Math.min(next_point[1],ctx_size[1]-80);
                return next_point;
            }
            
            dis=Math.round(border_work[2]*70/100);
            if(mt_rand(1,100)>prop){
                //1
                points.push([ctx_size[0],mt_rand(0,ctx_size[1])]);
                last_point=[border_work[1],mt_rand(0,ctx_size[1])];
                points.push(last_point);
            }
            else{
                //0
                points.push([0,mt_rand(0,ctx_size[1])]);
                last_point=[border_work[0],mt_rand(0,ctx_size[1])];
                points.push(last_point);
            }
            for(i=0;i<i_max;i++){
                last_point=findPoint(last_point);
                points.push(last_point);
            }
            points.push(point_center);
            this.animObj=new Smooth(points);
            this.pointNumber=points.length;
            this.step_max=120;
        }
        objCollisionPath.prototype={
            next:function(ctx,img){
                
                var size=[100,40];
                var scale=size[0]-(size[0]-size[1])*this.step/this.step_max;
                
                
                this.step=this.step+0.8;
                var pp=this.animObj(this.step/this.step_max*(this.pointNumber-1));
                var x=Math.round(pp[0]);
                var y=Math.round(pp[1]);
                
                if(this.collisionObj.eventType!=""){
                    if(!handleCollision(img,x,y,[img.width*scale/100,img.height*scale/100],0,this.collisionObj,this)){
                        if(this.collisionObj.eventType=="add"){
                            this.collisionObj.eventType="";
                           
                            th.startGirlAnim("addAnimLines",
                           [x,settings.height-y],
                           "puffw",20+20*scale/100,100,400,[100,40,0,0,0]); 
                           
                           return 0; 
                        }
                        if(this.collisionObj.eventType=="minus"){
//                            this.collisionObj.eventType="add";
//                            this.collisionObj.custom=this.step;
//                            this.imgName="good"+mt_rand(1,4);
                            this.collisionObj.eventType="";
                           
                            th.startGirlAnim("addAnimLines",
                           [x,settings.height-y],
                           "puffb",20+20*scale/100,100,400,[100,40,0,0,0]); 
                           
                           return 0; 
                        }
                        
                        
                        
                        
                        
                    }
                }
                

                
                y=settings.height-y;
                drawImage(ctx,img,x,y,scale);
                
                if(this.step>=this.step_max){
                    
                    th.trigger("moveEnd",{eventType:this.collisionObj.eventType,imgPos:[x,y]});
                    
                    return 0;
                    
                }
                return 1;
            }
        };
        
        
        
        
        
        function objCollisionThrow(img,conf){
            this.step=1;
            this.type=img;
            this.type_val=0;
            this.imgName=img;
            this.rotation_step=0;
            this.rotation_state=0;
            if(this.type=="egg"){
                this.type_val=mt_rand(0,4);
                this.imgName="egg"+this.type_val;
                this.rotation_step=mt_rand(3,20);
            }
            if(this.type=="chick"){
                this.type_val=0;
                this.imgName="chick"+this.type_val;
                 this.rotation_step=mt_rand(1,4);
            }
            this.collisionObj=prepareCollisionObj({eventType:this.type,easyMobile:0});
            var conf_all={g:0.4,h_max:1000,w_margin:50,boss_x:-1};
            var type_conf={
                "boss":{g:0.4,h_max:800}
            };
            if(typeof type_conf[this.type]=="object"){
                conf_all=$.extend(conf_all,type_conf[this.type]);
            }
            if(typeof conf=="object"){
                conf_all=$.extend(conf_all,conf);
            }
            
            this.g=conf_all.g;//1.1 trudność ustawia grawitacja!!!
            
            var v_range=[0,1000];
            var was_error=0;
            function takeVfromH(h,g,alfa){
                var val=Math.sqrt(h*2*g/Math.pow(Math.sin(alfa),2));
//                $.qLog(Math.round(val)+" ");
                return val;
            }
            function takeVfromR(r,g,alfa){
                var val=Math.sqrt(r*g/Math.sin(2*alfa));
//                $.qLog(Math.round(val)+" ");
                return val;
            }
            function takeVfromT(t,g,alfa){
               var val=(t*g/2/Math.sin(alfa));
//               $.qLog(Math.round(val)+" ");
               return val;
            }
            function updateV(v_min,v_max,tt){
                v_range[0]=Math.max(v_range[0],v_min);
                v_range[1]=Math.min(v_range[1],v_max);
                v_range[0]=Math.round(v_range[0]);
                v_range[1]=Math.round(v_range[1]);
                if(v_range[0]>v_range[1]){
                    was_error=1;
//                    $.qLog("ERROR"+tt+"v1:"+v_min+",v2:"+v_max+   " ");    
                }
            }
            //70-89
            var angle=mt_rand(70,89);
            this.angle=angle/180*Math.PI;
            
//            $.qLog("angle: "+Math.round(this.angle/Math.PI*180));
            var w_border=[conf_all.w_margin ,settings.width-conf_all.w_margin],w_border_len=w_border[1]-w_border[0];
            var h_range=[Math.round(settings.height*0.7),conf_all.h_max];
            var r_range=[10,w_border_len];
            var t_range=[20,300];
//            $.qLog("<br>H: ");
            updateV(
                takeVfromH(h_range[0],this.g,this.angle),
                takeVfromH(h_range[1],this.g,this.angle),
                1
            );
//    $.qLog("<br>R: ");
            updateV(
                takeVfromR(r_range[0],this.g,this.angle),   
                takeVfromR(r_range[1],this.g,this.angle),
                2
            );
//    $.qLog("<br>t: ");
            updateV(
                takeVfromT(t_range[0],this.g,this.angle),
                takeVfromT(t_range[1],this.g,this.angle),
                3
            );
    
//    $.qLog("<br><br>o: "+v_range[0]+" "+v_range[1]+"<br><br>");
            this.v0=mt_rand(v_range[0],v_range[1]);
            this.step_max=Math.ceil(2*this.v0*Math.sin(this.angle)/this.g);
            var range=Math.round(this.v0*this.v0*Math.sin(this.angle*2)/this.g);
            this.start=[w_border[0]+mt_rand(0,w_border_len-range),0];
            
            
            if(mt_rand(0,100)>50){
                this.start=[w_border[1]+w_border[0]-this.start[0],0];
                this.angle=Math.PI-this.angle;
            }
            if(this.type=="chick" && conf_all.boss_x!=-1){
                if(Math.abs(conf_all.boss_x-this.start[0])<50){
                    var sign=[-1,1];
                    this.start[0]=conf_all.boss_x+100*sign[mt_rand(0,1)];
                }
                //conf_all.boss_x
            }
            
            
            
//            this.step_max=1000;
        }
        objCollisionThrow.prototype={
            next:function(ctx,img){
                if(this.type=="chick"){
                    this.type_val=(this.type_val+1)%7;
                    this.imgName="chick"+this.type_val;
                }
                this.step=this.step+0.8;
                var x=this.v0*this.step*Math.cos(this.angle);
                var y=this.v0*this.step*Math.sin(this.angle)-(this.g*this.step*this.step)/2;
                var angle=0,angle_pi=0;
                if(this.rotation_step){
                    this.rotation_state=(this.rotation_state+this.rotation_step)%360;
                    angle=this.rotation_state;
                }
                
                x+=this.start[0];
                if(!handleCollision(img,x,y,[img.width,img.height],0,this.collisionObj,this)){
                    if(this.type=="egg"){
                        var qconf=[
                            [0,-150],
                            [150,0],
                            [0,150],
                            [-150,0]
                        ];
                        
                        var i,bum=[],bum_org,y_fix=settings.height-y;
                        angle_pi=angle*Math.PI/180;
                        
                        
                        
                        th.startGirlAnim("addAnimCustom",[x,y_fix],[x+mt_rand(-5,5),y_fix+mt_rand(10,30)],"egg_kill",50,[100,100],[100,20]);
                        for(i in qconf){
                            bum_org=qconf[i];
                            bum[0]=bum_org[0]*Math.cos(angle_pi)-bum_org[1]*Math.sin(angle_pi);
                            bum[1]=bum_org[0]*Math.sin(angle_pi)+bum_org[1]*Math.cos(angle_pi);
                            th.startGirlAnim("addAnimCustom",[x,y_fix],[x+bum[0],y_fix+bum[1]],this.imgName+"_"+i,10,[100,100],[100,20],[angle,mt_rand(angle+30,angle+90)]);
                        }
                        
                        
                    }
                    
                    
                    if(this.type=="chick"){
                        th.startGirlAnim("addAnimLines",[x,settings.height-y],"chick_f"+mt_rand(0,2));
                    }
                    
                    
                    if(this.type=="boss"){
                        if(this.collisionObj.cutNumber>=5){
                            
                            var qconf=[
                                [0,-150],
                                [-250,0],
                                [-200,100],
                                [0,150]
                            ];
                            var i,bum_org,y_fix=settings.height-y,qimg_name;
                            for(i in qconf){
                                bum_org=qconf[i];
                                qimg_name="boss_c"+(intval(i)+1);
                                th.startGirlAnim("addAnimCustom",[x,y_fix],[x+bum_org[0],y_fix+bum_org[1]],qimg_name,50,[100,100],[100,20],[0,mt_rand(10,40)]);
                            }
                            _eventLog[animIndex].push({event:"boss_killed"});
                            th.trigger("boss_killed");
                            return 0;
                        }
                    }
                    else{
                        return 0;
                    }
                    
                }

                
                y=settings.height-y;
                if(angle==0){
                    drawImage(ctx,img,x,y);
                }
                else{
                    drawRotatedImage(ctx,img,x, y, angle);
                }
                
                
                if(this.step>=this.step_max){
                    
                    _eventLog[animIndex].push({event:"moveEnd",eventType:this.collisionObj.eventType,imgPos:[x,y]});
                    th.trigger("moveEnd",{eventType:this.collisionObj.eventType,imgPos:[x,y]});
                    
                    return 0;
                    
                }
                return 1;
            },
            takeStartX:function(){
                return this.start[0];
            }
        };
        
        function objDrawElipse(center){
            this.step=5;
            this.step_max=100;
            this.a=settings.width/2*0.6;
            this.b=settings.height/2*0.6;
            this.series=2;
            if(typeof center[0]!="undefined"){
                this.start=copyArray(center);
            }
            else{
                this.start=[settings.width/2,settings.height/2];
            }
            
            this.imgName="heart";
        }
        objDrawElipse.prototype={
            next:function(ctx,img){
                var div=this.step/this.step_max;
                this.step+=(1+div*div*6)*1.3*0.8;
                var linear=-Math.pow(div*4,2)/16+1;
                linear=-Math.pow(div*100,2)/Math.pow(100,2)+1;
    //            linear=(this.step_max-this.step)/this.step_max;

                var x=this.a*linear*Math.cos(this.series*div*360* Math.PI/180);
                var y=this.b*linear*Math.sin(this.series*div*360* Math.PI/180);
                x+=this.start[0];
                y+=this.start[1];
                drawImage(ctx,img,x,y);
                if(this.step>=this.step_max){
                    th.startGirlAnim("addAnimLines",this.start,"heart",40);
                    th.trigger("endElipse");
                    return 0;
                    
                }
                return 1;
            }
        };
        
        function objDrawLines(start_point,img_name,scale,step_max,distance,opacity_arr){
            if(!img_name){
                img_name="heart";
            }
            if(!scale){
                scale=100;
            }
            if(!step_max){
                step_max=200;
            }
            this.start=[];
            if(typeof start_point!="undefined"){
                this.start[0]=start_point[0];
                this.start[1]=start_point[1];
            }
            else{
               this.start=[settings.width/2,settings.height/2]; 
            }
            var len=lengthVector(this.start)*2;
            if(distance){
                len=distance;
            }
            this.opacityLen=0;
            if(typeof opacity_arr!="undefined"){
                this.opacityLen=opacity_arr.length;
                this.opacityFun=new Smooth(opacity_arr);
            }
            this.scale=scale;
            this.step=1;
            this.step_max=step_max;
            this.imgName=img_name;
            
            
            
            this.arr_dir=[
                scaleVector([0,-1],len),
                scaleVector([0,1],len),
                scaleVector([1,Math.cos(360/5*Math.PI/180)],len),
                scaleVector([1,Math.cos(2*360/5*Math.PI/180)],len),
                scaleVector([-1,Math.cos(2*360/5*Math.PI/180)],len),
                scaleVector([-1,Math.cos(360/5*Math.PI/180)],len),
            ];
            this.rotate=mt_rand(0,360);
            
        }
        objDrawLines.prototype={
            next:function(ctx,img){
                var div=this.step/this.step_max;
                this.step+=(1+Math.pow(div-1,2))*1.3*0.8;
                var opacity=100;
                if(this.opacityLen){
                    opacity=Math.max(0,this.opacityFun(this.step/this.step_max*(this.opacityLen-1)));
                }
//                linear=1;
    //            linear=(this.step_max-this.step)/this.step_max;

                var x,y;
                var i,dir;
                for(i in this.arr_dir){
                    dir=this.arr_dir[i];
                    x=dir[0]*div;
                    y=dir[1]*div;
                    
                    ctx.save(); 
                    ctx.translate(this.start[0],this.start[1]);
                    ctx.rotate(this.rotate * Math.PI/180);
                    drawImage(ctx,img,x,y,this.scale,opacity);
                    ctx.restore();
                }
                
                
                if(this.step>=this.step_max){
                    return 0;
                }
                return 1;
            }
        };
        
        function objDrawCustom(start_point,end_point,img_name,step_max,scale_arr,opacity_arr,rotation_arr){
            if(!img_name){
                img_name="heart";
            }
            if(!step_max){
                step_max=200;
            }
            if(typeof scale_arr=="undefined"){
                scale_arr=[100,100];
            }
            if(typeof opacity_arr=="undefined"){
                opacity_arr=[100,100];
            }
            this.step=1;
            this.step_max=step_max;
            this.start_point=copyArray(start_point);
            this.end_point=copyArray(end_point);
            this.scale_arr=copyArray(scale_arr);
            this.opacity_arr=copyArray(opacity_arr);
            
            this.dir=makeVector(start_point,end_point);
            this.imgName=img_name;
            this.rotation_arr=[0,0];
            if(typeof rotation_arr!="undefined"){
                this.rotation_arr=copyArray(rotation_arr);
            }
        }
        objDrawCustom.prototype={
            next:function(ctx,img){
                var div=this.step/this.step_max;
                this.step+=1;
                
                var x=this.dir[0]*div+this.start_point[0],y=this.dir[1]*div+this.start_point[1];
                var scale=this.scale_arr[0]+(this.scale_arr[1]-this.scale_arr[0])*div;
                var opacity=this.opacity_arr[0]+(this.opacity_arr[1]-this.opacity_arr[0])*div;
                if(this.rotation_arr[0]==this.rotation_arr[1]){
                    drawImage(ctx,img,x,y,scale,opacity);
                }
                else{
                    var angle=this.rotation_arr[0]+(this.rotation_arr[1]-this.rotation_arr[0])*this.step/this.step_max;
                    drawRotatedImage(ctx,img,x, y, angle,scale,opacity);
                }
                
                
                 
                
                if(this.step>=this.step_max){
                    return 0;
                }
                
                
                
                return 1;
            }
        };
        
        function objDrawClipCustom(start_point,end_point,img_arr,step_max,clip_period){
            if(!step_max){
                step_max=200;
            }
            if(!clip_period){
                clip_period=step_max;
            }
            this.step=1;
            this.step_max=step_max;
            this.clip_period=clip_period;
            this.start_point=copyArray(start_point);
            this.end_point=copyArray(end_point);
            
            this.dir=makeVector(start_point,end_point);
            this.imgName=img_arr[0];
            this.imgArr=copyArray(img_arr);
        }
        objDrawClipCustom.prototype={
            next:function(ctx,img){
                var div=this.step/this.step_max;
                this.step+=1;
                
                var x=this.dir[0]*div+this.start_point[0],y=this.dir[1]*div+this.start_point[1];
                drawImage(ctx,img,x,y);
                if(this.step>=this.step_max){
                    return 0;
                }
                this.imgName=this.imgArr[this.step%this.clip_period];
                return 1;
            }
        };
        
        if(!settings){
            tryToInit=1;
            if(typeof options!="object"){
                return false;
            }
            settings=$.extend( {
                period:40,
                load_images:{
                    "heart":""+_IMG_SERV+"/gfx/place/girls/anim/heart.png",
                    "heart_broken":""+_IMG_SERV+"/gfx/place/girls/anim/heart_broken.png",
                },
                width:0,
                height:0,
                collision_easy:0
            }, options);
            
            function getNewAnimIndex(){
                var i=getNewObjectIndex(_animIndex,{});
                _animIndex[i]={period:timeHandler.getNewIndex()};
                _animStorage[i]={"obj_set":{}};
                return i;
            }
            if(typeof timeHandler=="undefined" || typeof timeHandler.getNewIndex=="undefined"){
                return false;//was not init
            }
            animIndex=getNewAnimIndex();
           
            var animIndexArr=_animIndex[animIndex];
            var imageAll={};
            settings.animIndex=animIndex;
            settings.width=intval(th.attr("width"));
            settings.height=intval(th.attr("height"));
            _collisionPointObj[animIndex]=[];
            _collisionPointObjArr[animIndex]=[];
            _collisionPointObjLast[animIndex]=[];
            _eventLog[animIndex]=[];
            _cutStorage[animIndex]=0;
            var ctx=th[0];
            ctx=ctx.getContext("2d");
            function prepareImages(){
                var i;
                for(i in settings.load_images){
                    imageAll[i]=new Image();
                    imageAll[i].src=settings.load_images[i];
                }
            }
            function preparePoints(){
                //_collisionPointObjArr
                _collisionPointObj[animIndex]
                if(typeof _collisionPointObjLast[animIndex][0]=="undefined"){
                    _collisionPointObjArr[animIndex].push(copyArray(_collisionPointObj[animIndex]));
                    return true;
                }
                var start_p=copyArray(_collisionPointObjLast[animIndex]),
                end_p=copyArray(_collisionPointObj[animIndex]);
                var distance2=Math.pow(start_p[0]-end_p[0],2)+Math.pow(start_p[1]-end_p[1],2);
                var step=10;
                if(distance2<=step*step){
                     _collisionPointObjArr[animIndex].push(copyArray(_collisionPointObj[animIndex]));
                    return true;
                }
                var distance=Math.sqrt(distance2),points_count=Math.ceil(distance/step);
                
                var dir=makeVector(start_p,end_p),i,p;
                for(i=1;i<=points_count;i++){
                    p=[Math.round(start_p[0]+dir[0]*i/points_count),Math.round(start_p[1]+dir[1]*i/points_count)]
                    _collisionPointObjArr[animIndex].push(copyArray(p));
//                    th.startGirlAnim("addAnimCustom",p,p,"point",30);
                }
                
                
                return true;
            }
            
            function drawScene(){
                ctx.clearRect(0, 0, settings.width, settings.height);
                if(typeof _animStorage[animIndex]!=="undefined"){
                    var i,is_ava,obj,all_anims=0;
                    
                    //_collisionPointAdr[animIndex]
                    if(typeof _collisionPointObj[animIndex][0]!="undefined"){
                        _collisionPointObjLast[animIndex][0]=_collisionPointObj[animIndex][0];
                        _collisionPointObjLast[animIndex][1]=_collisionPointObj[animIndex][1];
                    }
                    else{
                        _collisionPointObjLast[animIndex]=[];
                    }
                    
                    _collisionPointObj[animIndex]=[];
                    _collisionPointObjArr[animIndex]=[];
                    
                    if(typeof _collisionPointAdr[animIndex]!="undefined"){
                        _collisionPointObj[animIndex]=[_collisionPointAdr[animIndex][0],settings.height-_collisionPointAdr[animIndex][1]];
                        preparePoints();
                    }
                    
                    for(i in _animStorage[animIndex].obj_set){
                        obj=_animStorage[animIndex].obj_set[i];
                        if(typeof obj.next=="undefined"){

                        }
                        else{
                            if(typeof obj.imgName!="undefined"){
                                if(typeof imageAll[obj.imgName]!="undefined"){
                                    is_ava=obj.next(ctx,imageAll[obj.imgName]);
                                }
                                else{
                                    is_ava=0;
                                }
                            }
                            else{
                                is_ava=obj.next(ctx);
                            }
                        }

                        if(!is_ava){
                            delete _animStorage[animIndex].obj_set[i];
                            var imgName="";
                            if(typeof obj.imgName!="undefined"){
                                imgName=obj.imgName;
                            }
                            th.trigger("myGirlAnimEnd",imgName);
                        }
                        else{
                            all_anims;
                        }
                    }
                    th.trigger("myGirlAnimNumber",all_anims);
                }
                return true;
            }
            
            
            $("<div/>").one("myload",function(){
                prepareImages();
                timeHandler.set(animIndexArr.period,function(){
                    drawScene();
                },settings.period,function(){
                    delete _animIndex[animIndex];
                    delete _animStorage[animIndex];
                });
                th.data("myGirlAnim",settings);
                th.trigger("was_loaded");
            }).myLoad(settings.load_images);
            
            
            
            
        }
        else{
            var arg =Array.prototype.slice.call(arguments,1);
            animIndex=settings.animIndex;
            if(methods[options]){
                return methods[options].apply(this,arg);
            }
            
            
            
            
        }
        if(tryToInit==0){
            th.data("myGirlAnim",settings);
        }
        
        return true;
        
    };
});

